export default __webpack_public_path__ + "static/media/github_icon.f1baaa79.svg";